import { Controller } from "@hotwired/stimulus"

// Live "N / max" character counter for a textarea/input — used by the book
// form's description field.
export default class extends Controller {
  static targets = ["input", "count"]
  static values = { max: Number, warnAt: Number }

  connect() {
    this.update()
  }

  update() {
    const length = this.inputTarget.value.length
    this.countTarget.textContent = `${length} / ${this.maxValue}`
    this.countTarget.classList.toggle("hint-warn", this.hasWarnAtValue && length > this.warnAtValue)
  }
}
